import { useEditItem2 } from "../../../api/useNewItem";
import { useItemActionWithConfirmation } from "../../../api/useAction";
import { apiFetch } from "../../../api/core";
import { ContactNote, ContactNoteSchema } from "../types";

export const useContactNotes = (
  contactId: string | undefined,
  notesList: ContactNote[] | undefined,
  reloadInfo: () => void,
  apiPath: string
) => {
  const newNote = useEditItem2<Partial<ContactNote>>({
    save: async (item) => {
      if (!contactId || !item.message?.trim()) return item;
      
      let res;
      if (item._id) {
        // Edit existing
        res = await apiFetch(`${apiPath}/contact/${contactId}/note/${item._id}`, "put", {
          message: item.message,
        });
      } else {
        // Create new
        res = await apiFetch(`${apiPath}/contact/${contactId}/note`, "post", {
          message: item.message,
        });
      }
      
      reloadInfo();
      return res as ContactNote;
    }
  });

  const removeNote = useItemActionWithConfirmation<ContactNote, {}>(
    async (item) => {
      if (!contactId) return {};
      await apiFetch(`${apiPath}/contact/${contactId}/note/${item._id}`, "delete");
      reloadInfo();
      
      if (newNote.item?._id === item._id) {
        newNote.cancel();
      }
      return {};
    }, 
    {
      title: "Удалить заметку",
      memoTrigger: contactId,
    }
  );

  return {
    notes: notesList || [],
    schema: ContactNoteSchema,
    newNote,
    removeNote,
  };
};

export type ContactNotesHookData = ReturnType<typeof useContactNotes>;